<ul class="nav nav-tabs justify-content-start">
    <li class="nav-item">
      <a class="nav-link" routerLink="legajosAerovalesFacturas" routerLinkActive="active">Aerovales y facturas</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="legajosAuditorias" routerLinkActive="active">Auditor&iacute;as</a>
    </li>
  </ul>
  
  <router-outlet></router-outlet>
  